<template>
  <div>
    <div v-if="loading">loading...</div>
    <div v-if="!loading" class="table-responsive">
      <table class="table table-sm text-nowrap">
        <tr>
          <th>ID</th>
          <th>携帯電話国番号</th>
          <th>携帯電話番号</th>
          <th>姓_英字</th>
          <th>名_英字</th>
          <th>ミドルネーム 英字</th>
          <th>性別</th>
          <th>生年月日</th>
          <th>国籍</th>
          <th>居住地</th>
          <th>在留資格</th>
          <th>在留資格(その他)</th>
          <th>端末情報</th>
          <th>ステータス</th>
          <th>PID</th>
          <th>RedirectId</th>
          <th>Source</th>
          <th>ニックネーム</th>
          <th>登録日時</th>
          <th>更新日時</th>
        </tr>
        <tr v-for="(user, index) in this.users" :key="index">
          <td>{{ user.id }}</td>
          <td>{{ user.phoneCountryCode }}</td>
          <td>{{ user.phone }}</td>
          <td>{{ user.lastNameEn }}</td>
          <td>{{ user.firstNameEn }}</td>
          <td>{{ user.middleNameEn }}</td>
          <td>{{ user.sex }}</td>
          <td>{{ user.birthday }}</td>
          <td>{{ user.countryCode }}</td>
          <td>{{ user.prefCode }}</td>
          <td>{{ user.zairyu }}</td>
          <td>{{ user.zairyuOther }}</td>
          <td>{{ user.os }}</td>
          <td>{{ user.status }}</td>
          <td>{{ user.pid }}</td>
          <td>{{ user.redirectId }}</td>
          <td>{{ user.source }}</td>
          <td>{{ user.nickname }}</td>
          <td>{{ user.createdAt }}</td>
          <td>{{ user.updatedAt }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import master from "@/constants/MasterEnum";
import firebase from "firebase";
import utils from "@/utils/Utils";
import countries from "@/constants/CountriesEnum";
import sex from "@/constants/SexEnum";

export default {
  name: "usersInfo",
  mixins: [utils, master, countries, sex],
  data() {
    return {
      loading: false,
      db: firebase.firestore(),
      users: [],
      // copy:[],
    };
  },
  props: {
    firstDate: {
      type: Date,
      required: true,
    },
    lastDate: {
      type: Date,
      required: true,
    },
    pid: {
      type: String,
      required: false,
    },
    /*     redirectId: {
      type: String,
      required: false,
    }, */
    /*     bus:{
      type:Object,
      required:true,
    } */
  },
  created: function() {
    this.loading = true;
    let query = this.db.collection("users");
    if (this.pid !== "") {
      query = query.where("pid", "==", this.pid);
    }
    /* if (this.redirectId !== "") {
      query = query.where("redirectId", "==", this.redirectId);
    } */
    query
      .orderBy("created_at", "asc")
      .startAt(this.firstDate)
      .endAt(this.lastDate)
      .get()
      .then((query) => {
        query.forEach((doc) => {
          if (doc.exists) {
            var data = doc.data();
            if (data.phone !== undefined) {
              var item = {
                id: doc.id,
                lastNameEn: this.escapeNull(data.last_name_en),
                firstNameEn: this.escapeNull(data.first_name_en),
                middleNameEn: this.escapeNull(data.middle_name_en),
                nickname: this.escapeNull(data.nickname),
                zairyu: this.escapeNull(data.zairyuuShikaku),
                zairyuOther: this.escapeNull(data.zairyuOther),
                status: this.escapeNull(
                  this.userstatus.find((element) => {
                    return element.code == data.status;
                  }).value
                ),
                phone: this.escapeNull(data.phone),
                phoneCountryCode: this.escapeNull(data.phone_country_code),
                os: this.escapeNull(data.userAgentOS),
                pid: this.escapeNull(data.pid),
                redirectId: this.escapeNull(data.redirectId),
                source: this.escapeNull(data.source),
                createdAt: this.formatDateTime(data.created_at.toDate()),
                updatedAt: this.formatDateTime(data.updated_at.toDate()),
              };
              if (data.sex !== undefined) {
                item.sex = this.sex[data.sex];
              } else {
                item.sex = "";
              }
              if (data.birthday !== undefined) {
                item.birthday = this.formatDateTime(data.birthday.toDate());
              } else {
                item.birthday = "";
              }
              if (data.country_code !== undefined) {
                item.countryCode = this.escapeNull(
                  this.countries.find((element) => {
                    return element.code == data.country_code;
                  }).name
                );
              } else {
                item.countryCode = "";
              }
              if (data.pref_code !== undefined) {
                item.prefCode = this.escapeNull(
                  this.prefs.find((element) => {
                    return element.code == data.pref_code;
                  }).name
                );
              } else {
                item.prefCode = "";
              }
              this.users.push(item);
            }
          }
        });
      })
      .then(() => {
        this.loading = false;
        //this.copy=this.users;
        this.$emit(
          "bind-event",
          this.users,
          this.tsvFormat.userListInfo.fileName,
          this.tsvFormat.userListInfo.labels
        );
      });

    /*       this.bus.$on('search',((data)=>{
        this.pid=data.pid;
        this.redirectId=data.redirectId; */
    /*         if(data.pid=='' && data.redirectId==''){ // reset
          this.users=this.copy;
        }
        else if (data.pid!=='' && data.redirectId==''){
          let temp = this.copy.filter(item=>item.pid==data.pid);
          this.users=temp;
        }
        else if (data.pid=='' && data.redirectId!==''){
          let temp = this.copy.filter(item=>item.redirectId==data.redirectId);
          this.users=temp;
        }
        else{
          let temp = this.copy.filter(item=>item.pid==data.pid && item.redirectId==data.redirectId);
          this.users=temp;
        } */
    // }));
  },
};
</script>
